import { Component, inject, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { Router } from "@angular/router";

@Component({
  selector: "to-cert-item",
  templateUrl: "to-cert-item.html",
  styleUrls: ["../../shortcut-menu.scss"],
  imports: [TranslateModule, AngularSvgIconModule],
})
export class ToCertItem {
  private router = inject(Router);

  protected subscription = input.required();

  protected navigateToCert() {
    this.router.navigate(["cert", "ddos"]);
  }
}
